module.exports = "/assets/data/77c842607a7879eef4e431e0a0ac0ca6-IP32.data.json";